import React from "react";
import { Alert, Box, Paper, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const AlertColor = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Color
        </Typography>

        <Typography variant="body1">
          The color prop will override the default color for the specified
          severity.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Box mb={3}>
          <PreviewAndEditor
            language={"js"}
            value={
              '<Alert severity="success" color="info">\n' +
              "    This is a success alert — check it out!\n" +
              "</Alert>"
            }
          >
            <Stack direction={"column"} sx={{ width: "70%" }} spacing={2}>
              <Alert severity="success" color="info">
                This is a success alert — check it out!
              </Alert>
            </Stack>
          </PreviewAndEditor>
        </Box>
      </Paper>
    </Stack>
  );
};

export default AlertColor;
